var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"provincias container"},[_c('custom-select',{attrs:{"label":"Provincia","name":"provincia","value":_vm.value,"items":_vm.provincias},on:{"input":_vm.onChange,"focus":function($event){return _vm.$emit('focus')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }